import { OdinController, RadioGroup } from '@myosh/odin-components';
import { t } from 'i18next';
import { useMemo } from 'react';
import { getLabelOptions } from '../../../constants/label-configuration-options';
import type { LabelFormatType } from '../widget-settings-validation';
import type { DecimalConfigProps } from './DecimalConfiguration';
import DecimalConfiguration from './DecimalConfiguration';

interface LabelConfigProps extends DecimalConfigProps {
  watchLabelFormat?: LabelFormatType;
}
const PieChartLabelConfiguration = ({ control, watchLabelFormat, labelDecimals }: LabelConfigProps) => {
  const labelReadOnlyValue = useMemo(() => {
    if (watchLabelFormat) {
      return watchLabelFormat.value !== 'number';
    }
    return false;
  }, [watchLabelFormat]);

  return (
    <div className="my-2 flex flex-col pt-2">
      <OdinController
        name="labelFormat"
        control={control}
        render={({ field: { onChange, value } }) => (
          <RadioGroup
            name="labelFormat"
            data={getLabelOptions()}
            label={t('labelFormatting')}
            onChange={onChange}
            orientation="VERTICAL"
            textField="text"
            valueField="value"
            value={value}
          />
        )}
      />
      {labelReadOnlyValue ? (
        <DecimalConfiguration labelDecimals={labelDecimals} control={control} pieChartDecimal={true} nearestNumber />
      ) : null}
    </div>
  );
};

export default PieChartLabelConfiguration;
